<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 0">
                <base-button v-if="currentProfile == 'sp_sales_reports'" slot="title" type="success" class="dropdown-toggle">
                    BIR Reports - SP Sales Reports
                </base-button>
                <base-button v-else slot="title" type="success" class="dropdown-toggle">
                    BIR Reports - {{_.startCase(currentProfile)}}
                </base-button>
                <a v-for="profile in activeModules" :key="profile.id"
                    @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)"
                    class="dropdown-item" href="#">{{profile.name}}</a>
            </base-dropdown>
            <base-dropdown v-else>
                <base-button slot="title" type="primary" class="dropdown-toggle">
                    BIR Reports
                </base-button>
                <a class="dropdown-item" disabled>No active module/s under this feature</a>
            </base-dropdown>
        </base-header>
        <!-- <img style="display: none;" id='reportLogo' :src="imagepath" alt='Report Logo' crossorigin="anonymous"/> -->
        <div id="logoDiv" style="display: none;"></div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <sp-sales-report v-if="currentProfile == 'sp_sales_reports'"></sp-sales-report>
                    <pwd-sales-report v-if="currentProfile == 'pwd_sales_reports'"></pwd-sales-report>
                    <sales-summary-report v-if="currentProfile == 'bir_sales_reports'"></sales-summary-report>
                    <bir-consolidated-report v-if="currentProfile == 'bir_consolidated_reports'"> </bir-consolidated-report>
                    <sc-sales-report v-if="currentProfile == 'sc_sales_reports'"></sc-sales-report>
                    <gc-sales-report v-if="currentProfile == 'gc_sales_reports'"></gc-sales-report>
                    <gc-redeem-report v-if="currentProfile == 'gc_redeem_reports'"></gc-redeem-report>
                    <mov-sales-report v-if="currentProfile == 'mov_sales_reports'"></mov-sales-report>
                    <naac-sales-report v-if="currentProfile == 'naac_sales_reports'"></naac-sales-report>
                    <void-sales-report v-if="currentProfile == 'void_sales_reports'"></void-sales-report>
                    <return-sales-report v-if="currentProfile == 'return_sales_reports'"></return-sales-report>
                    <refund-sales-report v-if="currentProfile == 'refund_sales_reports'"></refund-sales-report>
                    <bir-consolidated-report v-if="currentProfile == 'bir_consolidated_reports'"> </bir-consolidated-report>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import SpSalesReport from '../Bir 5.1 Reports/SpSalesReport';
    import PwdSalesReport from '../Bir 5.1 Reports/PwdSalesReport';
    import SalesSummaryReport from '../Bir 5.1 Reports/SalesSummaryReport';
    import BirConsolidatedReport from './BirConsolidatedReport.vue';
    import ScSalesReport from '../Bir 5.1 Reports/ScSalesReport';
    import GcSalesReport from '../Bir 5.1 Reports/GcSalesReport';
    import GcRedeemReport from '../Bir 5.1 Reports/GcRedeemReport';
    import MovSalesReport from '../Bir 5.1 Reports/MovSalesReport';
    import NaacSalesReport from '../Bir 5.1 Reports/NaacSalesReport';
    import VoidSalesReport from '../Bir 5.1 Reports/VoidSalesReport';
    import ReturnSalesReport from '../Bir 5.1 Reports/ReturnSalesReport';
    import RefundSalesReport from '../Bir 5.1 Reports/RefundSalesReport';
    
    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        data() {
            return {
                activeModules: [],
                accessRights: [],
                imagepath: secureStorage.getItem("account_logo")
            }
        },
        mounted: async function () {
            var component_x = this;

            //Fix: S3 image CORS error in jsPDF
            const corsImageModified = new Image();
            corsImageModified.crossOrigin = "Anonymous";
            corsImageModified.id = "reportLogo";
            corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            document.getElementById("logoDiv").appendChild(corsImageModified);
            //Fix: S3 image CORS error in jsPDF

            var categoryId = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories?name=BIR 51 Reports', null, null)
            component_x.activeModules = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules', null, null)
            if (component_x.activeModules.length > 0) {
                var profile = _.snakeCase(component_x.activeModules[0].name)
                component_x.setCurrentProfile(_.pluralize(profile), component_x.activeModules[0].id);
            } else {
                component_x.setCurrentProfile(null, null);
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components: {
            SpSalesReport,
            PwdSalesReport,
            SalesSummaryReport,
            BirConsolidatedReport,
            ScSalesReport,
            GcSalesReport,
            GcRedeemReport,
            MovSalesReport,
            NaacSalesReport,
            VoidSalesReport,
            ReturnSalesReport,
            RefundSalesReport,
            BirConsolidatedReport
        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            async setCurrentProfile(profile, id) {
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[id]
                }else {
                    this.accessRights = []
                }
                this.updateCurrentProfile(profile);
            }
        }
    };
</script>

<style></style>
